<template>
  <WdsText :text="displayDateRange" class="tw-whitespace-pre-line tw-truncate" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import useDate from '@/composables/useDate'

const props = withDefaults(
  defineProps<{
    startDate: string | null
    endDate: string | null
    format?: string
    separator?: string
    fallback?: string
  }>(),
  {
    format: 'YYYY-MM-DD',
    separator: ' - ',
    fallback: '-',
  },
)

const formattedStartDate = useDate(
  computed(() => props.startDate),
  props.format,
)
const formattedEndDate = useDate(
  computed(() => props.endDate),
  props.format,
)

const displayDateRange = computed(() => {
  try {
    if (!props.startDate || !props.endDate) return props.fallback

    const startValid = formattedStartDate.isValid.value
    const endValid = formattedEndDate.isValid.value

    if (startValid && endValid) {
      return `${formattedStartDate.date.value} ${props.separator}\n${formattedEndDate.date.value}`
    }
    return props.fallback
  } catch (error) {
    return props.fallback
  }
})
</script>

<style scoped></style>
